export const keyCodes = {
  ENTER: "Enter",
  SPACE: " ",
  ESCAPE: "Escape",
  DOWN_ARROW: 40,
  UP_ARROW: 38,
  LEFT_ARROW: "ArrowLeft",
  RIGHT_ARROW: "ArrowRight"
};

export const SELECTION_KEYS = [keyCodes.ENTER, keyCodes.SPACE];
export const ESCAPE_KEYS = ["Esc", "Escape"];
